import React from "react";

import { LinkPillWithPopover } from "components/common/LinkPillWithPopover";
import strings from "components/release/useful-links/UsefulLinks.strings.json";
import styles from "components/release/useful-links/UsefulLinksAndroid.module.scss";
import { CHINA_STORES } from "util/platform";
import type { SemVer } from "util/version";
import { semVerString } from "util/version";

interface Props {
  versions: SemVer[];
  appBuildUrls: Record<string, string | undefined>;
}

const UsefulLinksChina = ({ versions, appBuildUrls }: Props) => {
  const generateChinaLinks = (version: SemVer, url: string | undefined) => {
    if (!url) {
      return null;
    }

    const baseUrl = url.replace(".apk", "");
    return CHINA_STORES.map((vendor, index) => (
      <React.Fragment key={vendor}>
        {index > 0 && " | "}
        <a href={`${baseUrl}_${vendor}.apk`} rel="noreferrer" target="_blank">
          {vendor}
        </a>
      </React.Fragment>
    ));
  };

  return (
    <span className={styles.container}>
      <LinkPillWithPopover
        linkPillTitle={strings.DownloadBuild}
        linkPillWidth="150px"
        popoverContent={
          <ul>
            {versions.map(version => {
              const url = appBuildUrls[semVerString(version)];
              return url ? (
                <li key={semVerString(version)}>
                  {semVerString(version)}: {generateChinaLinks(version, url)}
                </li>
              ) : null;
            })}
          </ul>
        }
      />
    </span>
  );
};

export default UsefulLinksChina;
